module.exports = __webpack_public_path__ + "img/arg.f3989473.svg";